import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const getRecurringEntitiesSchedule = gql`
  query GetRecurringEntitiesScheduleQuery($input: GetRecurringEntitiesSchedule!) {
    getRecurringEntitiesSchedule(input: $input) {
      ...RecurringEntitiesSchedule
    }
  }

  ${Fragments.entity.RecurringEntitiesSchedule}
`;
